/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import Cookies from 'js-cookie';

export const DELETE = async ({ url, body }: { url: string, body?: any }): Promise<any> => {
    const token = await Cookies.get('token') || '';
    const locale = await Cookies.get('language') || 'en';
    const response = await fetch(`${process.env.URI}${url}`, {
        method: 'DELETE',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token !== '' ? `Bearer ${token}` : '',
            'Accept-Language': locale
        },
        body: JSON.stringify(
            body
        )
    });
    return response.json();
};